import type { GetServerSideProps } from 'next';

import { withFixedPageCommonProps } from '@/utils/fixedPage';
import { getLocaleFromParams } from '@/utils/locale';

import { getFixedPageStaticProps } from '@/lib/commonPageStaticProps';
import { isWorldWideCatalogCountry } from '@/lib/util';
import { ShoppingBagView } from '@/views/ShoppingBagView';

export const getServerSideProps: GetServerSideProps = getFixedPageStaticProps(
  'store/shopping-bag',
  null,
  (context) => {
    const locale = getLocaleFromParams(context?.params);
    if (isWorldWideCatalogCountry(locale)) {
      return {
        notFound: true,
      };
    }
  },
);
export default withFixedPageCommonProps(ShoppingBagView);
